import { DeleteOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons';
import { Button, Space, Table, Tag } from 'antd';
import Column from 'antd/es/table/Column';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import ModalTextForm from '../../components/modal/ModalTextForm';
import { dateCommon } from '../../helpers/common';
import { ChiTietHopDongResponse, HopDong } from '../../models/hopdong/HopDong';
import { xoaHopDong } from '../../services/hopdong';
import LuuHopDongBox from './LuuHopDongBox';
import XemHopDongBox from './XemHopDongBox';

const DanhSachHopDongBox = ({ listData, hopDongInfo, select, defaultSelect, isThemMoi, onSubmit, idNhanVien, onRowSelected }: { listData?: Array<HopDong>, hopDongInfo: ChiTietHopDongResponse, select?: boolean, defaultSelect?: HopDong, isThemMoi?: boolean, onSubmit: () => void, idNhanVien: number, onRowSelected?: (e: any) => void }) => {
    var dataSource = (listData || []).map((item: any, index) => { item.key = index; return item; });
    const [hopDongSelected, setHopDongSelected] = useState<HopDong | undefined>(defaultSelect);

    const [modelProps, setModelProps] = useState<HopDong | null>(null);
    const [showLuuHopDong, setShowLuuHopDong] = useState(false);
    const [showXemHopDong, setShowXemHopDong] = useState(false);
    const [loading, setLoading] = useState(false);
    const [idXoaHopDong, setIdXoaHopDong] = useState<number>(0);
    useEffect(() => {
        setHopDongSelected(defaultSelect);
    }, [defaultSelect]);

    const xoaHopDongFE = async () => {
        try {
            setLoading(true);
            await xoaHopDong(idXoaHopDong);
            toast.success('Xoá hợp đồng thành công!');
        }
        catch (err: any) {
            toast.error('Đã xảy ra lỗi, xoá không thành công!');
        }
        setModelProps(null);
        setIdXoaHopDong(0);
        setLoading(false);
        onSubmit();
    }
    return (<>
        {idXoaHopDong > 0 && <ModalTextForm show={idXoaHopDong > 0}
            title="Xoá hợp đồng/Quyết định bổ nhiệm"
            handleClose={() => setIdXoaHopDong(0)}
            handleSave={() => xoaHopDongFE()}>
            Xác nhận xoá hợp đồng/Quyết định bổ nhiệm đang chọn?
        </ModalTextForm>
        }
        {showLuuHopDong &&
            <LuuHopDongBox
                modelProps={modelProps}
                title="Lưu hợp đồng/Quyết định bổ nhiệm"
                show={showLuuHopDong}
                idNhanVien={idNhanVien}
                onClose={() => setShowLuuHopDong(false)}
                onSubmit={() => onSubmit()} />
        }
        {showXemHopDong &&
            <XemHopDongBox
            show={showXemHopDong}
            onClose={() => setShowXemHopDong(false)}
            hopDongInfo={hopDongInfo} />
        }
        <Table
            locale={{ emptyText: "Không có dữ liệu" }}
            dataSource={dataSource}
            pagination={false}
            onRow={(record, rowIndex) => {
                if (select) {
                    return {
                        onClick: event => {
                            setHopDongSelected(record);
                            if (onRowSelected != null) {
                                onRowSelected(record);
                            }
                        },
                    };
                }
                return {};
            }}
            rowClassName={(record, index) => {
                return (select && record?.id === hopDongSelected?.id) ? "selected-row row-key-" : "";
            }}
        >
            <Column
                title="STT"
                key="STT"
                align="center"
                render={(value, record, index) =>
                (
                    <>
                        {index + 1}
                    </>
                )
                }
            />
            <Column
                title="Số hợp đồng/quyết định bổ nhiệm"
                key="soHopDong"
                dataIndex="soHopDong"
            />
            <Column
                title="Ngày ký"
                key="ngayKy"
                render={(value: HopDong, record, index) =>
                (
                    <>
                        {dateCommon.formatDate(value?.ngayKy)}
                    </>
                )
                }
            />
            <Column
                title="Từ ngày"
                key="ngayBatDau"
                render={(value: HopDong, record, index) =>
                (
                    <>
                        {dateCommon.formatDate(value?.ngayBatDau)}
                    </>
                )
                }
            />
            <Column
                title="Đến ngày"
                key="ngayKetThuc"
                render={(value: HopDong, record, index) =>
                (
                    <>
                        {dateCommon.formatDate(value?.ngayKetThuc)}
                    </>
                )
                }
            />
            <Column
                title="Trạng thái"
                key="trangThai"
                render={(value: HopDong, record, index) =>
                (
                    <Tag color={value.trangThai ? "green" : "red"}>{value.trangThai ? "Hiệu lực" : "Hết hiệu lực"}</Tag>
                )
                }
            />
            <Column
                title="Đóng BHXH"
                key="dongBHXH"
                render={(value: HopDong, record, index) =>
                (
                    <Tag color={value.isDongBHXH ? "green" : "red"}>{value.isDongBHXH ? "Đóng" : "Không đóng"}</Tag>
                )
                }
            />
            <Column width="10%" title="" key="action"
                render={(value: HopDong, record, index) =>
                (
                    <Space>
                        <Button type="primary" size={"small"} loading={loading} title="Xem"
                            icon=<EyeOutlined rev="" />
                            onClick={() => {
                                setModelProps(value);
                                setShowXemHopDong(true);
                            }}
                        >
                            Xem
                        </Button>
                        {isThemMoi &&
                            <>
                                <Button type="primary" size={"small"} loading={loading} title="Sửa"
                                    icon=<EditOutlined rev="" />
                                onClick={() => {
                                    setModelProps(value);
                                    setShowLuuHopDong(true);
                                }}
                                >
                                    Sửa
                                </Button>
                                <Button type="primary" danger size={"small"} loading={loading} title="Xóa"
                                    onClick={() => setIdXoaHopDong(value.id)}
                                    icon=<DeleteOutlined rev="" />
                                >
                                    Xóa
                                </Button>
                            </>
                        }
                    </Space>
                )}
            />
        </Table>
    </>
    );
};

export default DanhSachHopDongBox;
